import { __assign } from './external/tslib/tslib.es6.js';
import * as React from 'react';

var SvgBellFill = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "m19 11.958 3 5.975H2l3-5.975V9.677A5.972 5.972 0 0 1 8.316 4.33L11 2.996V2h2v.996l2.684 1.337A5.972 5.972 0 0 1 19 9.677v2.281ZM13 19.427v-.498h2v1.826L12 22l-3-1.245V18.93h2v.498l1 .415 1-.415Z", fill: "currentColor" }))); };

export { SvgBellFill as default };
